exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.right-track-info[data-v-23134073] {\n    max-width: 250px;\n    margin: 45px auto 40px auto;\n    text-align: center;\n    color: #333;\n}\n.v-icon[data-v-23134073] {\n    font-size: 16px;\n}\n", ""]);

